import { ContentType, HttpClient, RequestParams } from '../http-client';

export class CustomReport<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getCustomReportConfigs = (
    query?: {
      type?: string;
      [key: string]: any;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/custom-report/configs`,
      method: 'GET',
      ...(query && { query }),
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCustomReportConfigs = (
    data: any,
    query?: {
      type?: string;
      [key: string]: any;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/custom-report/configs`,
      method: 'POST',
      body: data,
      ...(query && { query }),
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  generateCustomReport = (data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/custom-report/generate`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  getCustomReportData = (
    query?: {
      type: string;
      month?: number;
      year?: number;
      vessel_type?: string;
      report?: string;
      vessel_id?: number;
    },
    params: RequestParams = {}
  ) =>
    this.http.request<any>({
      path: `/api/v2/custom-report/data`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...(query && { query }),
      ...params,
    });

  getCustomReportById = (id: string, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/custom-report/${id}`,
      method: 'GET',
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });

  updateCustomReportById = (id: string, data: any, params: RequestParams = {}) =>
      this.http.request<any>({
        path: `/api/v2/custom-report/entry/${id}`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

  updateCustomReportFcrAById = (id: string, data: any, params: RequestParams = {}) =>
    this.http.request<any>({
      path: `/api/v2/custom-report/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
